import {MenuStrategy} from "../MenuStrategy";

export class EmptyMenuStrategy extends MenuStrategy {
   constructor() {
    super('', '', '');
  }
}
